import React from 'react'
import { ModalProps, useModal } from '../modal'
import Modal from '../modal'
import WorkerCounterDetails from './worker-counter-details'
import { WorkerCounter } from '../../api/worker-counters'

interface WorkerCounterModalProps {
  workerCounter?: WorkerCounter
  isDisplayed: ModalProps['actions']['isDisplayed']
  setIsDisplayed: ModalProps['actions']['setIsDisplayed']
}

/**
 * Composant modal pour afficher les détails d'un compteur de travailleur
 * Utilise le composant WorkerCounterDetails pour afficher les informations
 */
const WorkerCounterModal: React.FC<WorkerCounterModalProps> = ({
  workerCounter,
  isDisplayed,
  setIsDisplayed,
}) => {
  return (
    <Modal
      actions={{ isDisplayed, setIsDisplayed }}
      title={
        workerCounter ? `Détails du compteur ${workerCounter.template.name}` : 'Détails du compteur'
      }
      maxWidth={800}
    >
      {workerCounter && <WorkerCounterDetails workerCounterId={workerCounter._id} />}
    </Modal>
  )
}

export default WorkerCounterModal
